<script lang="ts">
  import { createEventDispatcher } from "svelte";

  export let klass: string = "";
  export let disabled: boolean = false;
  export let altText: string = "";
  export let style: string = "";

  const dispatch = createEventDispatcher();

  function handleClick(event: Event) {
    dispatch("click", event);
  }
</script>

<button type="button" title={altText} class="button {klass}" {style} on:click={handleClick} {disabled}>
  <slot />
</button>
